var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("分类列表")])
          ]),
          _c("temp-table", {
            ref: "ref_1001",
            attrs: {
              "table-model": _vm.tableModel_1001.tableModel,
              "row-button": _vm.tableModel_1001.rowButton,
              "header-button": _vm.tableModel_1001.headerButton,
              "show-summary": _vm.tableModel_1001.showSummary,
              "show-pagination": _vm.tableModel_1001.showPagination,
              "show-selection": _vm.tableModel_1001.showSelection,
              "table-switch-props": _vm.tableModel_1001.tableSwitchProps,
              "table-select-props": _vm.tableModel_1001.tableSelectProps,
              "default-expand-all": _vm.tableModel_1001.defaultExpandAll,
              "row-key": _vm.tableModel_1001.rowKey,
              "tree-props": _vm.tableModel_1001.treeProps,
              "remote-func": _vm.remoteFunc,
              stripe: _vm.tableModel_1001.stripe,
              border: _vm.tableModel_1001.border,
              "req-table-data": _vm.reqTableData,
              "req-add": _vm.reqAdd,
              "req-del": _vm.reqDel,
              "on-click-link": _vm.onClickLink,
              "on-click-row-button": _vm.onClickRowButton,
              "on-click-header-button": _vm.onClickHeaderButton,
              "on-summary": _vm.onSummary,
              "on-switch-change": _vm.onSwitchChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }